import { SvgStar } from "assets";
import { gray2, gray4, gray7, iris, mainColor, white } from "assets/styleUtils";
import { ICompany } from "data/company";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.css";

export default function CompanyItem(item: ICompany) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        marginBottom: "16px",
        padding: "0 5px",
        cursor: "pointer",
      }}
      className={styles.imageHeight}
      onClick={() => {
        try {
          navigate(`/company/detail?no=${item.no}`);
        } catch (error) {
          console.error("navigate ScreenId.COMPANY_DETAIL error ", error);
        }
      }}
    >
      <div>
        <img
          src={
            item.photo[0]?.img_url
            // ? { uri: item.photo[0]?.img_url, priority: "low" }
            // : // : homeLogo
            //   null
          }
          style={{
            width: "100%",
            backgroundColor: gray7,
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: " 9px",
        }}
      >
        <div>
          <div
            style={{
              lineHeight: "18px",
              color: gray4,
              fontWeight: "bold",
              fontSize: "12px",
            }}
          >
            {(item.address || "주소정보없음")
              .split(" ")
              .filter(({}, i: number) => i < 2)
              .join(" ")}
          </div>
          <div
            style={{
              lineHeight: "18px",
              color: gray2,
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            {item.name.length > 10 ? item.name.slice(0, 10) + "..." : item.name}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              paddingTop: " 3px",
            }}
          >
            <SvgStar width={"15px"} fill={mainColor} />
            <div
              style={{
                lineHeight: "18px",
                color: gray2,
                fontSize: "12px",
                paddingLeft: " 3px",
                paddingRight: " 5px",
              }}
            >
              {item.totalRating || 0}
            </div>
            <img
              src="/images/comment.png"
              style={{ width: "14px", height: "14px" }}
            />
            <div
              style={{
                lineHeight: "18px",
                color: gray2,
                fontSize: "12px",
                paddingLeft: " 3px",
                paddingRight: " 5px",
              }}
            >
              {item.reviewCnt || 0}
            </div>
          </div>
        </div>
        <div>
          {item.additinal?.length > 0 && (
            <div
              style={{
                width: "36px",
                height: "20px",
                borderRadius: " 4px",
                backgroundColor: iris,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  color: white,
                  fontSize: "10px",
                }}
              >
                이벤트
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
